import * as React from "react";
import { cn } from "../cn";

export interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "size"> {
  invalid?: boolean;
  /** Visual size — distinct from the HTML `size` attribute. */
  inputSize?: "md" | "lg";
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = "text", invalid, inputSize = "md", ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      data-invalid={invalid || undefined}
      className={cn(
        "block w-full rounded-md border border-line-strong bg-paper text-ink",
        "px-3 transition-colors placeholder:text-ink-subtle",
        "focus:border-ink focus:outline-none focus:ring-2 focus:ring-ink/10",
        "disabled:cursor-not-allowed disabled:bg-paper-soft disabled:text-ink-muted",
        "data-[invalid]:border-danger data-[invalid]:focus:border-danger",
        inputSize === "md" && "h-10 text-[15px]",
        inputSize === "lg" && "h-12 text-lg",
        // numeric inputs render in tabular mono for readability
        (type === "number" || props.inputMode === "decimal") && "tabular",
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = "Input";
